export default __webpack_public_path__ + "static/media/icon-change-white.b156bc65.svg";